import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { VclButtonModule, VclDialogModule, VclStepsModule,
  VclAlertModule,
  VclAutocompleteModule,
  VclCardTemplateModule,
  VclDatepickerModule,
  VclFormFieldModule,
  VclInputModule,
  VclModalModule,
  VclSelectModule,
} from '@voxel/community';
import { VoxelHeaderModule, VoxelIconModule, VoxelLoadingModule,
  VoxelCheckboxModule,
  VoxelFormFieldModule,
  VoxelInputModule,
  VoxelLinkModule,
  VoxelModalModule,
} from '@voxel/mobile';
import { VclLoadingCircleModule } from '@flexds/community';

import { ControlsComponent } from './controls/controls-onboarding.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderOnboardingComponent } from './header/header-onboarding.component';
import { LoaderComponent } from './loader/loader.component';
import { ProductLoaderComponent } from './product-loader/product-loader.component';
import { OfficesSearchComponent } from './offices-search/offices-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PopupComponent } from './popup/popup.component';

/**
 * Configuración de los modulos de voxel
 *
 * *Voxel modules config*
 */
const voxelModules = [
  VoxelHeaderModule,
  VoxelIconModule,
  VoxelLoadingModule,
];

/**
 * Configuración de los modulos de voxel community
 *
 * *voxel community modules config*
 */
const voxelCommunityModules = [
  VclStepsModule,
  VclDialogModule,
  VclButtonModule,
];

@NgModule({
  imports: [
    CommonModule,
    ...voxelModules,
    ...voxelCommunityModules,
    VclLoadingCircleModule,
    FormsModule,
    ReactiveFormsModule,
    VclAlertModule,
    VclAutocompleteModule,
    VclCardTemplateModule,
    VclDatepickerModule,
    VclFormFieldModule,
    VclInputModule,
    VclModalModule,
    VclSelectModule,
    VoxelCheckboxModule,
    VoxelFormFieldModule,
    VoxelInputModule,
    VoxelLinkModule,
    VoxelModalModule,
  ],
  exports: [
    HeaderOnboardingComponent,
    FooterComponent,
    ControlsComponent,
    ProductLoaderComponent,
    LoaderComponent,
    ...voxelModules,
    ...voxelCommunityModules,
    OfficesSearchComponent,
    PopupComponent,
  ],
  providers: [],
  declarations: [
    HeaderOnboardingComponent,
    FooterComponent,
    ControlsComponent,
    ProductLoaderComponent,
    LoaderComponent,
    OfficesSearchComponent,
    PopupComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA,
  ],
})

export class SharedComponentsModule { }
